import { render } from "./VerClientes.vue?vue&type=template&id=60e6c886"
import script from "./VerClientes.vue?vue&type=script&lang=js"
export * from "./VerClientes.vue?vue&type=script&lang=js"

import "./VerClientes.vue?vue&type=style&index=0&id=60e6c886&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__